import React from "react";

import { IConfig, ISettings } from "./settingsTypes";
import { ILog } from "../Lib/Log/types";


export const SettingsContext = React.createContext<{ config: IConfig, settings: ISettings, log: ILog } | null>(null);

const SettingsProvider : React.FC<{config: IConfig, settings: ISettings, log: ILog, children: React.ReactNode}> = ({ config, settings, log, children }) => {

    const value = { config, settings, log };

    return (
        <SettingsContext.Provider value={value}>
          {children}
        </SettingsContext.Provider>
    );
};

export default SettingsProvider;